import router from "../router";

export default {
  state: {
    token: localStorage.getItem("token"),
    userName: localStorage.getItem("userName"),
    universityID: localStorage.getItem("scopeID"),
    facultyID: localStorage.getItem("facultyID"),
    facultyName: localStorage.getItem("facultyName"),
    branchID: localStorage.getItem("branchID"),
    branchName: localStorage.getItem("branchName"),
    scopeLevel: localStorage.getItem("scopeLevel") || 12,
    permissions: JSON.parse(localStorage.getItem("permissions") || "[]")
  },
  mutations: {
    logout(state: any) {
      state.token = "";
      state.userName = "";
      state.facultyID = null;
      state.facultyName = "";
      state.branchID = null;
      state.branchName = "";
      state.scopeLevel = "";
      state.permissions = [];

      localStorage.removeItem("token");
      localStorage.removeItem("userName");
      localStorage.removeItem("facultyID");
      localStorage.removeItem("facultyName");
      localStorage.removeItem("branchID");
      localStorage.removeItem("branchName");
      localStorage.removeItem("scopeID");
      localStorage.removeItem("scopeName");
      localStorage.removeItem("scopeLevel");
      localStorage.removeItem("permissions");

      router.push("/login");
    },

    login(state: any, payload: any) {
      state.token = payload.token;
      state.userName = payload.userName;
      state.permissions = payload.permissions || [];
      localStorage.token = payload.token;
      localStorage.userName = payload.userName;
      localStorage.permissions = JSON.stringify(payload.permissions || []);

    },
    refreshToken(state: any, payload: any) {
      state.token = payload.token;
      localStorage.token = payload.token;
    }
  },
  actions: {},
  getters: {
    getToken: (state: any) => state.token,
    getAllScopeLevel(state: any) {
      return {
        branchID:state.branchID,
        facultyID:state.facultyID,
        universityID:state.universityID || localStorage.getItem("scopeID")
      }
    },
    getPermissions: (state: any) => state.permissions,
    hasPermission: (state: any) => (perm: string) => {
      return state.permissions.includes(perm);
    }
  }
};
